// extracted by mini-css-extract-plugin
module.exports = {"tag-select":"QuestionForm_tag-select__3XbMo","checkbox":"QuestionForm_checkbox__2NsPM","disabled":"QuestionForm_disabled__1QQF5"};